'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var kea = require('kea');

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var loadersPlugin = function loadersPlugin(options) {
  if (options === void 0) {
    options = {};
  }

  var onStart = options.onStart || function () {};

  var onSuccess = options.onSuccess || function () {};

  var onFailure = options.onFailure || options.onError || function (_ref) {
    var error = _ref.error,
        actionKey = _ref.actionKey,
        reducerKey = _ref.reducerKey,
        logic = _ref.logic;
    console.error("Error in " + actionKey + " for " + reducerKey + ":", error);
  };

  return {
    name: 'loaders',
    defaults: function defaults() {
      return {
        loaders: undefined
      };
    },
    buildSteps: {
      loaders: function loaders(logic, input) {
        // skip if there are no loaders in the input
        if (!input.loaders) {
          return;
        } // run the loaders function with the already created logic as an input,
        // so it can do ({ actions, ... }) => ({ ... })


        var loaders = input.loaders(logic);
        Object.entries(loaders).forEach(function (_ref2) {
          var reducerKey = _ref2[0],
              actionsObject = _ref2[1];
          var defaultValue = logic.defaults[reducerKey];

          if (Array.isArray(actionsObject)) {
            if (typeof defaultValue === 'undefined') {
              defaultValue = actionsObject[0];
            }

            actionsObject = actionsObject[1] || {};
          }

          var _actionsObject = actionsObject,
              __default = _actionsObject.__default,
              realActions = _objectWithoutPropertiesLoose(_actionsObject, ["__default"]);

          if (typeof defaultValue === 'undefined' && typeof __default !== 'undefined') {
            defaultValue = typeof __default === 'function' ? __default() : __default;
          }

          if (typeof defaultValue === 'undefined') {
            defaultValue = null;
          } // extend the logic with these actions


          logic.extend({
            actions: function actions() {
              var newActions = {};
              Object.entries(realActions).forEach(function (_ref3) {
                var actionKey = _ref3[0],
                    listener = _ref3[1];

                if (typeof logic.actions["" + actionKey] === 'undefined') {
                  newActions["" + actionKey] = function (params) {
                    return params;
                  };
                }

                if (typeof logic.actions[actionKey + "Success"] === 'undefined') {
                  newActions[actionKey + "Success"] = function (value) {
                    var _ref4;

                    return _ref4 = {}, _ref4[reducerKey] = value, _ref4;
                  };
                }

                if (typeof logic.actions[actionKey + "Failure"] === 'undefined') {
                  newActions[actionKey + "Failure"] = function (error) {
                    return {
                      error: error
                    };
                  };
                }
              });
              return newActions;
            },
            reducers: function reducers(_ref5) {
              var actions = _ref5.actions;
              var reducerObject = {};
              var reducerLoadingObject = {};
              Object.keys(realActions).forEach(function (actionKey) {
                reducerObject[actions[actionKey + "Success"]] = function (_, _ref6) {
                  var value = _ref6[reducerKey];
                  return value;
                };

                reducerLoadingObject[actions["" + actionKey]] = function () {
                  return true;
                };

                reducerLoadingObject[actions[actionKey + "Success"]] = function () {
                  return false;
                };

                reducerLoadingObject[actions[actionKey + "Failure"]] = function () {
                  return false;
                };
              });
              var response = {};

              if (typeof logic.reducers[reducerKey] === 'undefined') {
                response[reducerKey] = [defaultValue, reducerObject];
              }

              if (typeof logic.reducers[reducerKey + "Loading"] === 'undefined') {
                response[reducerKey + "Loading"] = [false, reducerLoadingObject];
              }

              return response;
            },
            listeners: function listeners(_ref7) {
              var actions = _ref7.actions;
              var newListeners = {};
              Object.entries(realActions).forEach(function (_ref8) {
                var actionKey = _ref8[0],
                    listener = _ref8[1];

                newListeners[actions[actionKey]] = function (payload, breakpoint, action) {
                  try {
                    onStart && onStart({
                      actionKey: actionKey,
                      reducerKey: reducerKey,
                      logic: logic
                    });
                    var response = listener(payload, breakpoint, action);

                    if (response && response.then && typeof response.then === 'function') {
                      return response.then(function (asyncResponse) {
                        onSuccess && onSuccess({
                          response: response,
                          actionKey: actionKey,
                          reducerKey: reducerKey,
                          logic: logic
                        });
                        actions[actionKey + "Success"](asyncResponse);
                      })["catch"](function (error) {
                        if (!kea.isBreakpoint(error)) {
                          onFailure && onFailure({
                            error: error,
                            actionKey: actionKey,
                            reducerKey: reducerKey,
                            logic: logic
                          });
                          actions[actionKey + "Failure"](error.message);
                        }
                      });
                    } else {
                      onSuccess && onSuccess({
                        response: response,
                        actionKey: actionKey,
                        reducerKey: reducerKey,
                        logic: logic
                      });
                      actions[actionKey + "Success"](response);
                    }
                  } catch (error) {
                    if (!kea.isBreakpoint(error)) {
                      onFailure && onFailure({
                        error: error,
                        actionKey: actionKey,
                        reducerKey: reducerKey,
                        logic: logic
                      });
                      actions[actionKey + "Failure"](error.message);
                    }
                  }
                };
              });
              return newListeners;
            }
          });
        });
      }
    },
    buildOrder: {
      loaders: {
        after: 'defaults'
      }
    }
  };
};

exports.loadersPlugin = loadersPlugin;
